import PropTypes from "prop-types";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footerButtons,
  closeOnOutsideClick,
  className = "",
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (closeOnOutsideClick) onClose();
  };

  const stopPropagation = (e) => e.stopPropagation();

  return (
//    <div className="modal-overlay" onClick={handleBackdropClick}>
//   <div className="modal-root" onClick={stopPropagation}>
//     <div className="modal-header">
//       {title && <h3 className="modal-title">{title}</h3>}
//       <X className="modal-close" onClick={onClose} />
//     </div>

//     <div className="modal-body">{children}</div>

//     {footerButtons && (
//       <div className={`modal-footer ${className}`}>
//         {footerButtons.map((btn, index) => (
//           <button
//             key={index}
//             disabled={btn.disabled ?? false}
//             onClick={btn.onClick}
//             className={btn.className || "modal-button"}
//           >
//             {btn.render ?? btn.text}
//           </button>
//         ))}
//       </div>
//     )}
//   </div>
// </div>
<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={handleBackdropClick}>
  <div className="bg-white w-full max-w-2xl rounded-2xl relative max-h-[90vh] overflow-hidden" onClick={stopPropagation}>
    {/* Header */}
    <div className="p-2 md:p-6 border-b border-gray-100">
      <div className="flex items-center justify-between">
        {title && (
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
        )}
        <button
          className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
          onClick={onClose}
        >
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    {/* Content */}
    <div className="p-2 max-h-[60vh] overflow-auto">
      {children}
    </div>

    {/* Footer */}
    {footerButtons && (
      <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
        <div className={`flex justify-end gap-3 ${className}`}>
          {footerButtons.map((btn, index) => (
            <button
              key={index}
              disabled={btn.disabled ?? false}
              onClick={btn.onClick}
              className={btn.className || "px-4 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"}
            >
              {btn.render ?? btn.text}
            </button>
          ))}
        </div>
      </div>
    )}
  </div>
</div>

  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  footerButtons: PropTypes.array,
  closeOnOutsideClick: PropTypes.bool,
  className: PropTypes.string,
};

export default Modal;
